const functions = {
	leverage: {
		inputs: {
			shortTermDebts: { variable: 'shortTermDebts' },
			longTermDebt: { variable: 'longTermDebt' },
			totalEquity: { variable: 'totalEquity' }
		},
		f:
			'( i.shortTermDebts + i.longTermDebt ) / ( i.totalEquity + i.shortTermDebts + i.longTermDebt )'
	},

	debtEquityRatio: {
		inputs: {
			longTermDebt: { variable: 'longTermDebt' },
			equity: { variable: 'equity' }
		},
		f: '( i.longTermDebt ) / ( i.equity )'
	},

	shortTermDebtsOnRevenues: {
		inputs: {
			shortTermDebts: { variable: 'shortTermDebts' },
			revenues: { variable: 'revenues' }
		},
		f: 'i.shortTermDebts / i.revenues'
	},

	buildingsSaturation: {
		inputs: {
			machines: { variable: 'machines' },
			machinesPerBuilding: { variable: 'machinesPerBuilding' }
		},
		f: '(i.machines % i.machinesPerBuilding)== 1? 0 : 2'
	},

	equity: {
		inputs: {
			capitalExpenditures: { variable: 'capitalExpenditures' },
			last: { variable: 'equity', timeshift: 1 }
		},
		f: 'f.getEquity( i.capitalExpenditures, time, i.last, i.builtinArgs )'
	},

	roi: {
		inputs: {
			operatingIncome: { variable: 'operatingIncome' },
			totalAssets: { variable: 'totalAssets' }
		},
		f: 'i.operatingIncome / i.totalAssets'
	},

	ros: {
		inputs: {
			operatingIncome: { variable: 'operatingIncome' },
			revenues: { variable: 'revenues' }
		},
		f: 'i.operatingIncome / i.revenues'
	},

	roe: {
		inputs: {
			netIncome: { variable: 'netIncome' },
			equity: { variable: 'equity' },
			retainedEarnings: { variable: 'retainedEarnings' }
		},
		f: 'i.netIncome / ( i.equity + i.retainedEarnings )'
	},

	roa: {
		inputs: {
			operatingIncome: { variable: 'operatingIncome' },
			totalAssets: { variable: 'totalAssets' }
		},
		f: 'i.operatingIncome / i.totalAssets'
	},

	cccSales: {
		inputs: {
			endingWhJuice: { variable: 'endingWhJuice' },
			endingWhApples: { variable: 'endingWhApples' },
			endingWhBottles: { variable: 'endingWhBottles' },
			accountReceivables: { variable: 'accountReceivables' },
			accountPayables: { variable: 'accountPayables' },
			revenues: { variable: 'revenues' }
		},
		f:
			'( i.endingWhJuice + i.endingWhApples + i.endingWhBottles + i.accountReceivables - i.accountPayables ) / i.revenues'
	},

	cashGrowthRate: {
		inputs: {
			cash: { variable: 'cash' },
			cash_last: { variable: 'cash', timeshift: 1 }
		},
		f: 'i.cash_last === 0? 0 : ( i.cash / i.cash_last ) - 1'
	},

	endingWhJuice: {
		inputs: {
			neededJuice: { variable: 'neededJuice' }
		},
		f: 'Math.max(i.neededJuice,0)'
	},

	neededJuice: {
		inputs: {
			producedUnits: { variable: 'producedUnits' },
			beginningWhJuice: { variable: 'beginningWhJuice' },
			soldUnits: { variable: 'soldUnits' }
		},
		f: 'i.beginningWhJuice + i.producedUnits - i.soldUnits'
	},

	endingWhJuiceOnProducedUnits: {
		inputs: {
			producedUnits: { variable: 'producedUnits' },
			endingWhJuice: { variable: 'endingWhJuice' }
		},
		f: 'i.endingWhJuice / i.producedUnits'
	},

	endingWhApplesOnProducedUnits: {
		inputs: {
			producedUnits: { variable: 'producedUnits' },
			endingWhApples: { variable: 'endingWhApples' }
		},
		f: 'i.endingWhApples / i.producedUnits'
	},

	endingWhBottlesOnProducedUnits: {
		inputs: {
			producedUnits: { variable: 'producedUnits' },
			endingWhBottles: { variable: 'endingWhBottles' }
		},
		f: 'i.endingWhBottles / i.producedUnits'
	},
	endingWhJuiceOnPurchasedUnits: {
		inputs: {
			deliveredUnits: { variable: 'deliveredUnits' },
			endingWhJuice: { variable: 'endingWhJuice' }
		},
		f: 'i.endingWhJuice / i.deliveredUnits'
	},

	endingWhApplesOnPurchasedUnits: {
		inputs: {
			deliveredUnits: { variable: 'deliveredUnits' },
			endingWhApples: { variable: 'endingWhApples' }
		},
		f: 'i.endingWhApples / i.deliveredUnits'
	},

	endingWhBottlesOnPurchasedUnits: {
		inputs: {
			deliveredUnits: { variable: 'deliveredUnits' },
			endingWhBottles: { variable: 'endingWhBottles' }
		},
		f: 'i.endingWhBottles / i.deliveredUnits'
	},

	// CONTROLLATE

	// PERFORMANCE VARIABLES

	soldUnits: {
		inputs: {
			demandQuota: { variable: 'demandQuota' },
			size: { variable: 'size' }
		},
		f: 'i.demandQuota * i.size'
	},

	deliveredUnits: {
		inputs: {
			soldUnits: { variable: 'soldUnits' },
			producedUnits: { variable: 'producedUnits' }
		},
		f: 'Math.min( i.soldUnits, i.producedUnits )'
	},

	demandQuota: {
		inputs: {
			performance: { variable: 'performance' }
		},
		f: 'f.demandQuota( i.performance, i.builtinArgs )'
	},

	performance: {
		inputs: {
			pricePerformance: { variable: 'pricePerformance' },
			daysReceivablePerformance: { variable: 'daysReceivablePerformance' },
			daysReceivableImportance: { variable: 'daysReceivableImportance' },
			qualityPerformance: { variable: 'qualityPerformance' },
			marketingPerformance: { variable: 'marketingPerformance' },
			qualityImportance: { variable: 'qualityImportance' },
			marketingImportance: { variable: 'marketingImportance' }
		},
		f:
			'i.pricePerformance * ( i.qualityPerformance * i.qualityImportance + i.marketingPerformance * i.marketingImportance + i.daysReceivablePerformance * i.daysReceivableImportance )'
	},

	pricePerformance: {
		inputs: {
			price: { variable: 'price' }
		},
		f: 'f.pricePerformance(i.price, i.builtinArgs)'
	},

	qualityPerformance: {
		inputs: {
			supplierAppleChoice: { variable: 'supplierAppleChoice' },
			qualityCheckPersonel: { variable: 'qualityCheckPersonel' },
			recyclingAndWasteManagement: { variable: 'recyclingAndWasteManagement' },
			qualityMaintenance: { variable: 'qualityMaintenance' },
			juiceTaster: { variable: 'juiceTaster' },
			chemicalExpert: { variable: 'chemicalExpert' }
		},
		f:
			'f.qualityPerformance( i.supplierAppleChoice, i.qualityCheckPersonel, i.recyclingAndWasteManagement, i.qualityMaintenance, i.juiceTaster, i.chemicalExpert, i.builtinArgs )'
	},

	qualityImportance: {
		inputs: {
			price: { variable: 'price' }
		},
		f: 'f.qualityImportance( i.price, i.builtinArgs )'
	},

	quality: {
		inputs: {
			qualityPerformance: { variable: 'qualityPerformance' }
		},
		f: 'i.qualityPerformance * 5'
	},

	daysReceivablePerformance: {
		inputs: {
			daysReceivable: { variable: 'daysReceivable' }
		},
		f: 'f.daysReceivablePerformance( i.daysReceivable, i.builtinArgs )'
	},

	daysReceivableImportance: {
		f: '0.1'
	},

	marketingImportance: {
		inputs: {
			price: { variable: 'price' }
		},
		f: 'f.marketingImportance( i.price, i.builtinArgs )'
	},

	marketingPerformance: {
		inputs: {
			marketingExpenses: { variable: 'marketingExpenses' },
			supplierBottleChoice: { variable: 'supplierBottleChoice' }
		},
		f:
			'f.marketingPerformance( i.marketingExpenses, i.supplierBottleChoice, i.builtinArgs  )'
	},

	// TEST PERFORMANCE VARIABLES

	supposedSoldUnits: {
		inputs: {
			supposedDemandQuota: { variable: 'supposedDemandQuota' },
			size: { variable: 'size' }
		},
		f: 'i.supposedDemandQuota * i.size'
	},

	supposedDemandQuota: {
		inputs: {
			supposedPerformance: { variable: 'supposedPerformance' }
		},
		f: 'f.demandQuota( i.supposedPerformance, i.builtinArgs )'
	},

	supposedPerformance: {
		inputs: {
			pricePerformance: { variable: 'supposedPricePerformance' },
			daysReceivablePerformance: {
				variable: 'supposedDaysReceivablePerformance'
			},
			qualityPerformance: { variable: 'supposedQuality' },
			marketingPerformance: { variable: 'supposedMarketingPerformance' },
			daysReceivableImportance: {
				variable: 'supposedDaysReceivableImportance'
			},
			qualityImportance: { variable: 'supposedQualityImportance' },
			marketingImportance: { variable: 'supposedMarketingImportance' }
		},
		f:
			'i.pricePerformance * ( ( i.qualityPerformance / 5 ) * i.qualityImportance + i.daysReceivablePerformance * i.daysReceivableImportance  + i.marketingPerformance * i.marketingImportance)'
	},

	supposedPricePerformance: {
		inputs: {
			supposedPrice: { variable: 'supposedPrice' }
		},
		f: 'f.pricePerformance(i.supposedPrice, i.builtinArgs)'
	},

	supposedQualityImportance: {
		inputs: {
			supposedPrice: { variable: 'supposedPrice' }
		},
		f: 'f.qualityImportance( i.supposedPrice, i.builtinArgs )'
	},

	supposedDaysReceivableImportance: {
		inputs: {
			supposedPrice: { variable: 'supposedPrice' }
		},
		f: '0.1'
	},

	supposedDaysReceivablePerformance: {
		inputs: {
			supposedDaysReceivable: { variable: 'supposedDaysReceivable' }
		},
		f: 'f.daysReceivablePerformance( i.supposedDaysReceivable, i.builtinArgs )'
	},

	supposedMarketingImportance: {
		inputs: {
			supposedPrice: { variable: 'supposedPrice' }
		},
		f: 'f.marketingImportance( i.supposedPrice, i.builtinArgs )'
	},

	supposedMarketingPerformance: {
		inputs: {
			supposedMarketingExpenses: { variable: 'supposedMarketingExpenses' },
			supplierBottleChoice: { variable: 'supplierBottleChoice' }
		},
		f:
			'f.marketingPerformance( i.supposedMarketingExpenses, i.supplierBottleChoice, i.builtinArgs )'
	},

	//PRODUCTION

	machineries: {
		inputs: {
			machines: { variable: 'machines' },
			machineCost: { variable: 'machineCost' },
			machineryDepreciation: { variable: 'machineryDepreciation' }
		},
		f: '(i.machines*i.machineCost)'
	},

	machineProductionCapacityUsage: {
		inputs: {
			machines: { variable: 'machines' },
			machineProductionCapacity: { variable: 'machineProductionCapacity' },
			machineProductionCapacityUsageQuota: {
				variable: 'machineProductionCapacityUsageQuota'
			}
		},
		f:
			'i.machines * i.machineProductionCapacity * i.machineProductionCapacityUsageQuota / 100'
	},

	totalProductionCapacityAtFullUsage: {
		inputs: {
			machines: { variable: 'machines' },
			machineProductionCapacity: { variable: 'machineProductionCapacity' }
		},
		f: 'i.machines * i.machineProductionCapacity'
	},

	internallyProducedUnits: {
		inputs: {
			machineProductionCapacityUsage: {
				variable: 'machineProductionCapacityUsage'
			}
		},
		f: 'i.machineProductionCapacityUsage'
	},

	// OUTSOURCING

	outsourcedUnits: {
		inputs: {
			outsourcingQuota: { variable: 'outsourcingQuota' },
			soldUnits: { variable: 'soldUnits' }
		},
		f: '(i.outsourcingQuota/100)*i.soldUnits'
	},

	outsourcedProductionCosts: {
		inputs: {
			outsourcedUnits: { variable: 'outsourcedUnits' },
			outsourcingUnitCost: { variable: 'outsourcingUnitCost' }
		},
		f: 'i.outsourcedUnits*i.outsourcingUnitCost'
	},

	producedUnits: {
		inputs: {
			outsourcedUnits: { variable: 'outsourcedUnits' },
			internallyProducedUnits: { variable: 'internallyProducedUnits' }
		},
		f: 'i.outsourcedUnits + i.internallyProducedUnits'
	},

	// DEPRECIATION

	machinesTotalCost: {
		inputs: {
			machineCost: { variable: 'machineCost' },
			machines: { variable: 'machines' }
		},
		f: 'i.machineCost * i.machines'
	},

	machineryUnitDepreciation: {
		inputs: {
			machineCost: { variable: 'machineCost' },
			machineryDepreciationPeriod: { variable: 'machineryDepreciationPeriod' }
		},
		f: 'i.machineCost/i.machineryDepreciationPeriod'
	},

	machineryDepreciation: {
		inputs: {
			machines: { variable: 'machines' },
			machineryUnitDepreciation: { variable: 'machineryUnitDepreciation' }
		},
		f: 'i.machines*i.machineryUnitDepreciation'
	},

	// WORKERS

	indirectManPowerCosts: {
		inputs: {
			logisticPersonelUnitCost: { variable: 'logisticPersonelUnitCost' },
			machines: { variable: 'machines' }
		},
		f: 'i.logisticPersonelUnitCost*i.machines'
	},

	// INVENTORY

	beginningWhJuice: {
		inputs: {
			endingWhJuice_last: { variable: 'endingWhJuice', timeshift: 1 }
		},
		f: 'i.endingWhJuice_last'
	},

	beginningWhBottles: {
		inputs: {
			endingWhBottles_last: { variable: 'endingWhBottles', timeshift: 1 }
		},
		f: 'i.endingWhBottles_last'
	},

	supplyNeedsBottles: {
		inputs: {
			beginningWhBottles: { variable: 'beginningWhBottles' },
			producedUnits: { variable: 'producedUnits' },
			bomEmptyBottles: { variable: 'bomEmptyBottles' }
		},
		f:
			'Math.round(Math.max((i.producedUnits * i.bomEmptyBottles) - i.beginningWhBottles,0))'
	},

	soldBottles: {
		inputs: {
			beginningWhBottles: { variable: 'beginningWhBottles' },
			soldUnits: { variable: 'soldUnits' },
			bomEmptyBottles: { variable: 'bomEmptyBottles' }
		},
		f: 'Math.round(Math.max((i.soldUnits * i.bomEmptyBottles),0))'
	},

	outsourcedBottles: {
		inputs: {
			beginningWhBottles: { variable: 'beginningWhBottles' },
			outsourcedUnits: { variable: 'outsourcedUnits' },
			bomEmptyBottles: { variable: 'bomEmptyBottles' }
		},
		f: 'Math.round(Math.max((i.outsourcedUnits * i.bomEmptyBottles),0))'
	},

	supplierOrderBottles: {
		inputs: {
			supplyNeedsBottles: { variable: 'supplyNeedsBottles' },
			supplierBottleChoice: { variable: 'supplierBottleChoice' },
			c1: { variable: 'supplier1MinimumLotBottles' },
			c2: { variable: 'supplier2MinimumLotBottles' },
			c3: { variable: 'supplier3MinimumLotBottles' }
		},
		f:
			'Math.ceil(i.supplyNeedsBottles/[i.c1,i.c2,i.c3][i.supplierBottleChoice-1]) * [i.c1,i.c2,i.c3][i.supplierBottleChoice-1]'
	},

	endingWhBottles: {
		inputs: {
			beginningWhBottles: { variable: 'beginningWhBottles' },
			supplierOrderBottles: { variable: 'supplierOrderBottles' },
			producedUnits: { variable: 'producedUnits' },
			bomEmptyBottles: { variable: 'bomEmptyBottles' }
		},
		f:
			'Math.max(i.beginningWhBottles + i.supplierOrderBottles - (i.producedUnits*i.bomEmptyBottles),0)'
	},

	beginningWhApples: {
		inputs: {
			endingWhApples_last: { variable: 'endingWhApples', timeshift: 1 }
		},
		f: 'i.endingWhApples_last'
	},

	supplyNeedsApples: {
		inputs: {
			producedUnits: { variable: 'producedUnits' },
			bomApples: { variable: 'bomApples' },
			beginningWhApples: { variable: 'beginningWhApples' }
		},
		f:
			'Math.round(Math.max(( i.producedUnits * i.bomApples ) - i.beginningWhApples,0))'
	},

	soldApples: {
		inputs: {
			soldUnits: { variable: 'soldUnits' },
			bomApples: { variable: 'bomApples' },
			beginningWhApples: { variable: 'beginningWhApples' }
		},
		f: 'Math.round(Math.max(( i.soldUnits * i.bomApples ),0))'
	},

	outsourcedApples: {
		inputs: {
			outsourcedUnits: { variable: 'outsourcedUnits' },
			bomApples: { variable: 'bomApples' },
			beginningWhApples: { variable: 'beginningWhApples' }
		},
		f: 'Math.round(Math.max(( i.outsourcedUnits * i.bomApples ),0))'
	},

	supplierOrderApples: {
		inputs: {
			supplyNeedsApples: { variable: 'supplyNeedsApples' },
			supplierAppleChoice: { variable: 'supplierAppleChoice' },
			c1: { variable: 'supplier1MinimumLotApples' },
			c2: { variable: 'supplier2MinimumLotApples' },
			c3: { variable: 'supplier3MinimumLotApples' }
		},
		f:
			'Math.ceil(i.supplyNeedsApples/[i.c1,i.c2,i.c3][i.supplierAppleChoice-1]) * [i.c1,i.c2,i.c3][i.supplierAppleChoice-1]'
	},

	endingWhApples: {
		inputs: {
			beginningWhApples: { variable: 'beginningWhApples' },
			supplierOrderApples: { variable: 'supplierOrderApples' },
			producedUnits: { variable: 'producedUnits' },
			bomApples: { variable: 'bomApples' }
		},
		f:
			'Math.max(i.beginningWhApples + i.supplierOrderApples - (i.producedUnits*i.bomApples),0)'
	},

	// REPORTS

	revenues: {
		inputs: {
			soldUnits: { variable: 'soldUnits' },
			price: { variable: 'price' }
		},
		f: 'i.soldUnits*i.price'
	},

	directMaterialCosts: {
		inputs: {
			supplierAppleChoice: { variable: 'supplierAppleChoice' },
			soa: { variable: 'soldApples' },
			osoa: { variable: 'outsourcedApples' },
			ca1: { variable: 'supplier1CostApples' },
			ca2: { variable: 'supplier2CostApples' },
			ca3: { variable: 'supplier3CostApples' },
			supplierBottleChoice: { variable: 'supplierBottleChoice' },
			sob: { variable: 'soldBottles' },
			osob: { variable: 'outsourcedBottles' },
			cb1: { variable: 'supplier1CostBottles' },
			cb2: { variable: 'supplier2CostBottles' },
			cb3: { variable: 'supplier3CostBottles' }
		},
		f:
			'(i.sob - i.osob) * [i.cb1, i.cb2, i.cb3][i.supplierBottleChoice-1] + (i.soa - i.osoa) * [i.ca1, i.ca2, i.ca3][i.supplierAppleChoice-1]'
	},

	contributionMargin: {
		inputs: {
			revenues: { variable: 'revenues' },
			directMaterialCosts: { variable: 'directMaterialCosts' },
			outsourcedProductionCosts: { variable: 'outsourcedProductionCosts' },
			sellingCommissions: { variable: 'sellingCommissions' }
		},
		f:
			'i.revenues - i.directMaterialCosts - i.outsourcedProductionCosts -i.sellingCommissions'
	},

	qualityCheckCosts: {
		inputs: {
			qualityCheckUnitCost: { variable: 'qualityCheckUnitCost' },
			qualityCheckPersonel: { variable: 'qualityCheckPersonel' },
			machines: { variable: 'machines' }
		},
		f: 'i.qualityCheckUnitCost * i.qualityCheckPersonel * i.machines'
	},

	qualityCheckPersonelTotalInvestments: {
		inputs: {
			machines: { variable: 'machines' },
			qualityCheckPersonel: { variable: 'qualityCheckPersonel' },
			qualityCheckPersonelLast: {
				variable: 'qualityCheckPersonel',
				timeshift: 1
			},
			qualityCheckInitialInvestment: {
				variable: 'qualityCheckInitialInvestment'
			},
			qualityCheckInvestmentPersonelUnit: {
				variable: 'qualityCheckInvestmentPersonelUnit'
			}
		},
		f:
			'(( i.qualityCheckInvestmentPersonelUnit * (i.qualityCheckPersonel - i.qualityCheckPersonelLast) + (time === 1 ? i.qualityCheckInitialInvestment : 0) ) * i.machines)'
	},

	qualityCheckPersonelTotalCosts: {
		inputs: {
			machines: { variable: 'machines' },
			qualityCheckPersonel: { variable: 'qualityCheckPersonel' },
			qualityCheckPersonelUnitCost: { variable: 'qualityCheckPersonelUnitCost' }
		},
		f: 'i.machines * i.qualityCheckPersonel * i.qualityCheckPersonelUnitCost'
	},
	qualityCheckPersonelDepreciation: {
		inputs: {
			machines: { variable: 'machines' },
			qualityCheckPersonel: { variable: 'qualityCheckPersonel' },
			qualityCheckInitialInvestment: {
				variable: 'qualityCheckInitialInvestment'
			},
			qualityCheckInvestmentPersonelUnit: {
				variable: 'qualityCheckInvestmentPersonelUnit'
			},
			machineryDepreciationPeriod: { variable: 'machineryDepreciationPeriod' }
		},
		f:
			'((i.machines * i.qualityCheckPersonel * i.qualityCheckInvestmentPersonelUnit) + ( i.machines * i.qualityCheckInitialInvestment ) * (i.qualityCheckPersonel >= 1))/i.machineryDepreciationPeriod'
	},
	recyclingAndWasteManagementTotalCosts: {
		inputs: {
			machines: { variable: 'machines' },
			recyclingAndWasteManagementUnitCost: {
				variable: 'recyclingAndWasteManagementUnitCost'
			},
			recyclingAndWasteManagement: { variable: 'recyclingAndWasteManagement' }
		},
		f:
			'i.machines * i.recyclingAndWasteManagementUnitCost * i.recyclingAndWasteManagement'
	},
	qualityMaintenanceTotalCosts: {
		inputs: {
			machines: { variable: 'machines' },
			qualityMaintenanceUnitCost: { variable: 'qualityMaintenanceUnitCost' },
			qualityMaintenance: { variable: 'qualityMaintenance' }
		},
		f: 'i.machines * i.qualityMaintenanceUnitCost * i.qualityMaintenance'
	},
	juiceTasterTotalCost: {
		inputs: {
			machines: { variable: 'machines' },
			juiceTasterUnitCost: { variable: 'juiceTasterUnitCost' },
			juiceTaster: { variable: 'juiceTaster' }
		},
		f: 'i.machines * i.juiceTasterUnitCost * i.juiceTaster'
	},
	chemicalExpertTotalCost: {
		inputs: {
			totalBuildings: { variable: 'totalBuildings' },
			chemicalExpertUnitCost: { variable: 'chemicalExpertUnitCost' },
			chemicalExpert: { variable: 'chemicalExpert' }
		},
		f: 'i.totalBuildings * i.chemicalExpertUnitCost * i.chemicalExpert'
	},

	qualityTotalCosts: {
		inputs: {
			qualityCheckPersonelTotalCosts: {
				variable: 'qualityCheckPersonelTotalCosts'
			},
			qualityCheckPersonelDepreciation: {
				variable: 'qualityCheckPersonelDepreciation'
			},
			recyclingAndWasteManagementTotalCosts: {
				variable: 'recyclingAndWasteManagementTotalCosts'
			},
			qualityMaintenanceTotalCosts: {
				variable: 'qualityMaintenanceTotalCosts'
			},
			juiceTasterTotalCost: { variable: 'juiceTasterTotalCost' },
			chemicalExpertTotalCost: { variable: 'chemicalExpertTotalCost' }
		},
		f:
			'i.qualityCheckPersonelTotalCosts + i.qualityCheckPersonelDepreciation + i.recyclingAndWasteManagementTotalCosts + i.qualityMaintenanceTotalCosts + i.juiceTasterTotalCost + i.chemicalExpertTotalCost'
	},

	productionOverheads: {
		inputs: {
			qualityTotalCosts: { variable: 'qualityTotalCosts' },
			machineryDepreciation: { variable: 'machineryDepreciation' },
			buildingRentTotal: { variable: 'buildingRentTotal' },

			machines: { variable: 'machines' },
			utilities: { variable: 'utilities' },

			indirectManPowerCosts: { variable: 'indirectManPowerCosts' },
			indirectMaterialCosts: { variable: 'indirectMaterialCosts' },
			machineProductionCapacityUsageQuota: {
				variable: 'machineProductionCapacityUsageQuota'
			}
		},
		f:
			'i.qualityTotalCosts + i.machineryDepreciation + i.buildingRentTotal + i.machines*i.utilities + i.indirectManPowerCosts + (i.indirectMaterialCosts*i.machines * (i.machineProductionCapacityUsageQuota / 100 ))'
	},

	sellingCommissions: {
		inputs: {
			sellingCommissionRate: { variable: 'sellingCommissionRate' },
			revenues: { variable: 'revenues' }
		},
		f: 'i.sellingCommissionRate * i.revenues'
	},

	marketingAndSellingExpenses: {
		inputs: {
			sellingExpenses: { variable: 'sellingExpenses' },
			marketingExpenses: { variable: 'marketingExpenses' }
		},
		f: 'i.sellingExpenses+i.marketingExpenses'
	},

	generalAndAdministrativeExpenses: {
		inputs: {
			totalGenaralExpenses: { variable: 'totalGenaralExpenses' },
			otherAssetsDepreciation: { variable: 'otherAssetsDepreciation' }
		},
		f: 'i.totalGenaralExpenses + i.otherAssetsDepreciation'
	},

	operatingIncome: {
		inputs: {
			contributionMargin: { variable: 'contributionMargin' },
			productionOverheads: { variable: 'productionOverheads' },
			marketingAndSellingExpenses: { variable: 'marketingAndSellingExpenses' },
			generalAndAdministrativeExpenses: {
				variable: 'generalAndAdministrativeExpenses'
			}
		},
		f:
			'i.contributionMargin-i.productionOverheads-i.marketingAndSellingExpenses-i.generalAndAdministrativeExpenses'
	},

	avarageDailyPurchaseCosts: {
		inputs: {
			directMaterialCosts: { variable: 'directMaterialCosts' },
			workingDays: { variable: 'workingDays' }
		},
		f: 'i.directMaterialCosts/i.workingDays'
	},

	avarageDailyOutsourcingCosts: {
		inputs: {
			outsourcedProductionCosts: { variable: 'outsourcedProductionCosts' },
			workingDays: { variable: 'workingDays' }
		},
		f: 'i.outsourcedProductionCosts/i.workingDays'
	},

	outsourcingAccountPayables: {
		inputs: {
			avarageDailyOutsourcingCosts: {
				variable: 'avarageDailyOutsourcingCosts'
			},
			outsourcingDaysPayable: { variable: 'outsourcingDaysPayable' }
		},
		f: 'i.avarageDailyOutsourcingCosts*i.outsourcingDaysPayable'
	},

	investmentOffices: {
		inputs: {
			offices: { variable: 'offices' },
			officesLast: { variable: 'offices', timeshift: 1 }
		},
		f: 'i.offices - i.officesLast'
	},

	investmentITinfrastructures: {
		inputs: {
			ITinfrastructures: { variable: 'ITinfrastructures' },
			ITinfrastructuresLast: { variable: 'ITinfrastructures', timeshift: 1 }
		},
		f: 'i.ITinfrastructures - i.ITinfrastructuresLast'
	},

	investmentAutomobilesVehicles: {
		inputs: {
			AutomobilesVehicles: { variable: 'AutomobilesVehicles' },
			AutomobilesVehiclesLast: { variable: 'AutomobilesVehicles', timeshift: 1 }
		},
		f: 'i.AutomobilesVehicles - i.AutomobilesVehiclesLast'
	},

	netOffices: {
		inputs: {
			offices: { variable: 'offices' },
			otherAssetsDepreciationPeriod: {
				variable: 'otherAssetsDepreciationPeriod'
			}
		},
		f: 'i.offices - ( time * (i.offices / i.otherAssetsDepreciationPeriod) )'
	},

	netITinfrastructures: {
		inputs: {
			ITinfrastructures: { variable: 'ITinfrastructures' },
			otherAssetsDepreciationPeriod: {
				variable: 'otherAssetsDepreciationPeriod'
			}
		},
		f:
			'i.ITinfrastructures - ( time * (i.ITinfrastructures / i.otherAssetsDepreciationPeriod) )'
	},

	netAutomobilesVehicles: {
		inputs: {
			AutomobilesVehicles: { variable: 'AutomobilesVehicles' },
			otherAssetsDepreciationPeriod: {
				variable: 'otherAssetsDepreciationPeriod'
			}
		},
		f:
			'i.AutomobilesVehicles - ( time * (i.AutomobilesVehicles / i.otherAssetsDepreciationPeriod) )'
	},

	totalOtherInvestments: {
		inputs: {
			offices: { variable: 'investmentOffices' },
			ITinfrastructures: { variable: 'investmentITinfrastructures' },
			AutomobilesVehicles: { variable: 'investmentAutomobilesVehicles' }
		},
		f: '(i.offices + i.ITinfrastructures + i.AutomobilesVehicles)'
	},

	totalOtherAssets: {
		inputs: {
			offices: { variable: 'offices' },
			ITinfrastructures: { variable: 'ITinfrastructures' },
			AutomobilesVehicles: { variable: 'AutomobilesVehicles' },
			otherAssetsDepreciation: { variable: 'otherAssetsDepreciation' }
		},
		f: '(i.offices + i.ITinfrastructures + i.AutomobilesVehicles)'
	},

	otherAssetsDepreciation: {
		inputs: {
			offices: { variable: 'offices' },
			ITinfrastructures: { variable: 'ITinfrastructures' },
			AutomobilesVehicles: { variable: 'AutomobilesVehicles' },
			otherAssetsDepreciationPeriod: {
				variable: 'otherAssetsDepreciationPeriod'
			}
		},
		f:
			'(i.offices + i.ITinfrastructures + i.AutomobilesVehicles)/i.otherAssetsDepreciationPeriod'
	},

	productionAssets: {
		inputs: {
			machineries: { variable: 'machineries' }
		},
		f: 'i.machineries'
	},

	productionInvestments: {
		inputs: {
			machines: { variable: 'machines' },
			machineCost: { variable: 'machineCost' }
		},
		f: 'time === 1 ? (i.machines * i.machineCost) : 0'
	},

	productionAssetsDepreciation: {
		inputs: {
			machineryDepreciation: { variable: 'machineryDepreciation' }
		},
		f: 'i.machineryDepreciation'
	},

	fixedAssets: {
		inputs: {
			qualityCheckPersonelTotalInvestments: {
				variable: 'qualityCheckPersonelTotalInvestments'
			},
			qualityCheckPersonelTotalInvestments_y1: {
				variable: 'qualityCheckPersonelTotalInvestments',
				timeshift: 1
			},
			qualityCheckPersonelTotalInvestments_y2: {
				variable: 'qualityCheckPersonelTotalInvestments',
				timeshift: 2
			},
			productionAssets: { variable: 'productionAssets' },
			totalOtherAssets: { variable: 'totalOtherAssets' }
		},
		f:
			'i.productionAssets+i.totalOtherAssets+i.qualityCheckPersonelTotalInvestments + i.qualityCheckPersonelTotalInvestments_y1 + i.qualityCheckPersonelTotalInvestments_y2'
	},

	fixedAssetsDepreciation: {
		inputs: {
			productionAssetsDepreciation: {
				variable: 'productionAssetsDepreciation'
			},
			otherAssetsDepreciation: { variable: 'otherAssetsDepreciation' },
			qualityCheckPersonelDepreciation: {
				variable: 'qualityCheckPersonelDepreciation'
			}
		},
		f:
			'i.productionAssetsDepreciation+i.otherAssetsDepreciation+i.qualityCheckPersonelDepreciation'
	},

	accumulatedDepreciation: {
		inputs: {
			fixedAssetsDepreciation: { variable: 'fixedAssetsDepreciation' },
			fixedAssetsDepreciation_last_y1: {
				variable: 'fixedAssetsDepreciation',
				timeshift: 1
			},
			fixedAssetsDepreciation_last_y2: {
				variable: 'fixedAssetsDepreciation',
				timeshift: 2
			}
		},
		f:
			'i.fixedAssetsDepreciation + i.fixedAssetsDepreciation_last_y1 + i.fixedAssetsDepreciation_last_y2'
	},

	//NOTE si potrebbe togliere
	equityDelta: {
		inputs: {
			equity_last: { variable: 'equity', timeshift: 1 },
			equity: { variable: 'equity' }
		},
		f: 'i.equity - i.equity_last'
	},

	additionalNeedsOfFunds: {
		inputs: {
			capitalExpenditures: { variable: 'capitalExpenditures' },
			equity: { variable: 'equityDelta' }
		},
		f: 'Math.max(0, i.capitalExpenditures - i.equity)'
	},

	additionalNeedsOfFundsDelta: {
		inputs: {
			additionalNeedsOfFunds_last: {
				variable: 'additionalNeedsOfFunds',
				timeshift: 1
			},
			additionalNeedsOfFunds: { variable: 'additionalNeedsOfFunds' }
		},
		f: 'i.additionalNeedsOfFunds - i.additionalNeedsOfFunds_last'
	},

	longTermDebtDelta: {
		inputs: {
			longTermDebt: { variable: 'longTermDebt' },
			last: { variable: 'longTermDebt', timeshift: 1 }
		},
		f: 'i.longTermDebt - i.last'
	},

	fixedAssetsDelta: {
		inputs: {
			fixedAssets_last: { variable: 'fixedAssets', timeshift: 1 },
			fixedAssets: { variable: 'fixedAssets' }
		},
		f: 'i.fixedAssets - i.fixedAssets_last'
	},

	capitalExpenditures: {
		inputs: {
			productionInvestments: { variable: 'productionInvestments' },
			qualityCheckPersonelTotalInvestments: {
				variable: 'qualityCheckPersonelTotalInvestments'
			},
			totalOtherInvestments: { variable: 'totalOtherInvestments' }
		},
		f:
			'i.productionInvestments + i.totalOtherInvestments + i.qualityCheckPersonelTotalInvestments'
	},

	longTermDebt: {
		inputs: {
			additionalNeedsOfFunds: { variable: 'additionalNeedsOfFunds' },
			longTermDebt_last: { variable: 'longTermDebt', timeshift: 1 }
		},
		f: 'i.longTermDebt_last + i.additionalNeedsOfFunds'
	},

	// longInterestRateTerm: {
	//   inputs : {
	//     longTermDebt : { variable : "longTermDebt" },
	//     longInterestRateA : { variable : "longInterestRateA" },
	//     longInterestRateB : { variable : "longInterestRateB" },
	//     longInterestRateC : { variable : "longInterestRateC" },
	//     longInterestThresholdA : { variable : "longInterestThresholdA" },
	//     longInterestThresholdB : { variable : "longInterestThresholdB" },
	//   },
	//   f : 'f.longInterestRateTerm(i.longTermDebt, i.longInterestRateA, i.longInterestRateB, i.longInterestRateC, i.longInterestThresholdA, i.longInterestThresholdB )'
	// },

	interestExpensesLongTerm: {
		inputs: {
			longInterestRateTerm: { variable: 'longInterestRateTerm' },
			longTermDebt: { variable: 'longTermDebt' }
		},
		f: 'i.longInterestRateTerm * i.longTermDebt'
	},

	preTaxIncome: {
		inputs: {
			operatingIncome: { variable: 'operatingIncome' },
			interestExpensesLongTerm: { variable: 'interestExpensesLongTerm' }
		},
		f: 'i.operatingIncome-i.interestExpensesLongTerm'
	},

	preTaxIncomeWithShortTerm: {
		inputs: {
			preTaxIncome: { variable: 'preTaxIncome' },
			interesetExpensesOnBankOverdraft: {
				variable: 'interesetExpensesOnBankOverdraft'
			}
		},
		f: 'i.preTaxIncome-i.interesetExpensesOnBankOverdraft'
	},

	taxes: {
		inputs: {
			taxRate: { variable: 'taxRate' },
			preTaxIncomeWithShortTerm: { variable: 'preTaxIncomeWithShortTerm' }
		},
		f:
			'i.preTaxIncomeWithShortTerm > 0 ? i.taxRate*i.preTaxIncomeWithShortTerm : 0'
	},

	netIncome: {
		inputs: {
			preTaxIncomeWithShortTerm: { variable: 'preTaxIncomeWithShortTerm' },
			taxes: { variable: 'taxes' }
		},
		f: 'i.preTaxIncomeWithShortTerm-i.taxes'
	},

	cashFlowFromOperations: {
		inputs: {
			netIncome: { variable: 'netIncome' },
			fixedAssetsDepreciation: { variable: 'fixedAssetsDepreciation' },
			inventoryDelta: { variable: 'inventoryDelta' },
			receivablesDelta: { variable: 'receivablesDelta' },
			payablesDelta: { variable: 'payablesDelta' }
		},
		f:
			'i.netIncome + i.fixedAssetsDepreciation + i.inventoryDelta + i.receivablesDelta + i.payablesDelta'
	},

	shortTermDebts: {
		inputs: {
			taxRate: { variable: 'taxRate' },
			preTaxIncome: { variable: 'preTaxIncome' },
			fixedAssetsDepreciation: { variable: 'fixedAssetsDepreciation' },
			inventoryDelta: { variable: 'inventoryDelta' },
			receivablesDelta: { variable: 'receivablesDelta' },
			payablesDelta: { variable: 'payablesDelta' },
			shortTermDebtsLast: { variable: 'shortTermDebts', timeshift: 1 },
			lastYearCash: { variable: 'lastYearCash' }
		},
		// formula originale di gianluca
		//f : '(+(i.inventoryDelta+i.receivablesDelta+i.payablesDelta)-(i.preTaxIncome*(1-i.taxRate))-i.fixedAssetsDepreciation + i.shortTermDebtsLast)/((1-(0.05*(1-i.taxRate))))'

		// aggiunto max 0
		// f: 'Math.max(0,(( - i.inventoryDelta - i.receivablesDelta - i.payablesDelta ) - ( i.preTaxIncome * ( 1 - i.taxRate ) ) - i.fixedAssetsDepreciation + i.shortTermDebtsLast ) / ( ( 1 - ( 0.05 * ( 1 - i.taxRate ) ) ) ) )'
		f:
			'f.shortTermDebtFormula( i.inventoryDelta, i.receivablesDelta, i.payablesDelta, i.preTaxIncome, i.fixedAssetsDepreciation, i.shortTermDebts, i.taxRate, i.shortTermDebtsLast, i.lastYearCash, i.builtinArgs )'
		//f : '10'
	},

	shortTermDebtsBalanceSheet: {
		inputs: {
			shortTermDebts: { variable: 'shortTermDebts' },
			lastYearCash: { variable: 'lastYearCash' }
		},
		f: 'Math.max( 0, i.shortTermDebts - i.lastYearCash)'
	},

	interesetExpensesOnBankOverdraft: {
		inputs: {
			shortTermDebts: { variable: 'shortTermDebts' }
		},
		f: 'Math.max(0,i.shortTermDebts) * 0.05'
	},

	// shortTermDebts: {
	//   inputs : {
	//     cashFlowFromOperations : { variable : "cashFlowFromOperations" },
	//     shortTermDebts_last : { variable : "shortTermDebts", timeshift : 1 },
	//   },
	//   f : 'Math.max( 0, i.shortTermDebts_last - i.cashFlowFromOperations )'
	// },

	shortTermDebtsDelta: {
		inputs: {
			shortTermDebts: { variable: 'shortTermDebts' },
			shortTermDebts_last: { variable: 'shortTermDebts', timeshift: 1 }
		},
		f: 'i.shortTermDebts - i.shortTermDebts_last'
	},

	financingCashFlow: {
		inputs: {
			longTermDebtDelta: { variable: 'longTermDebtDelta' },
			shortTermDebtsDelta: { variable: 'shortTermDebtsDelta' },
			equityDelta: { variable: 'equityDelta' }
		},
		f: 'i.longTermDebtDelta + i.shortTermDebtsDelta + i.equityDelta'
	},

	lastYearCash: {
		inputs: {
			cash_last: { variable: 'cash', timeshift: 1 }
		},
		f: 'Math.max( 0, i.cash_last )'
	},

	totalCashFlow: {
		inputs: {
			lastYearCash: { variable: 'lastYearCash' },
			cashFlowFromOperations: { variable: 'cashFlowFromOperations' },
			capitalExpenditures: { variable: 'capitalExpenditures' },
			financingCashFlow: { variable: 'financingCashFlow' }
		},
		f:
			'i.cashFlowFromOperations-i.capitalExpenditures+i.financingCashFlow + i.lastYearCash + 0.0001'
	},

	cash: {
		inputs: {
			totalCashFlow: { variable: 'totalCashFlow' },
			shortTermDebts: { variable: 'shortTermDebts' }
		},
		f: 'Math.max( 0, i.totalCashFlow )'
	},

	daysInPayablesApples: {
		inputs: {
			index: { variable: 'supplierAppleChoice' },
			s1: { variable: 'supplier1daysInPayablesApples' },
			s2: { variable: 'supplier2daysInPayablesApples' },
			s3: { variable: 'supplier3daysInPayablesApples' }
		},
		f: '[i.s1,i.s2,i.s3][i.index-1]'
	},

	daysInPayablesBottles: {
		inputs: {
			index: { variable: 'supplierBottleChoice' },
			s1: { variable: 'supplier1daysInPayablesBottles' },
			s2: { variable: 'supplier2daysInPayablesBottles' },
			s3: { variable: 'supplier3daysInPayablesBottles' }
		},
		f: '[i.s1,i.s2,i.s3][i.index-1]'
	},

	purchaseCostsApples: {
		inputs: {
			index: { variable: 'supplierAppleChoice' },
			s1: { variable: 'supplier1CostApples' },
			s2: { variable: 'supplier2CostApples' },
			s3: { variable: 'supplier3CostApples' },
			orders: { variable: 'supplierOrderApples' }
		},
		f: '[i.s1,i.s2,i.s3][i.index-1]*i.orders'
	},

	purchaseCostsBottles: {
		inputs: {
			index: { variable: 'supplierBottleChoice' },
			s1: { variable: 'supplier1CostBottles' },
			s2: { variable: 'supplier2CostBottles' },
			s3: { variable: 'supplier3CostBottles' },
			orders: { variable: 'supplierOrderBottles' }
		},
		f: '[i.s1,i.s2,i.s3][i.index-1]*i.orders'
	},

	avarageDailyPurchaseCostsApples: {
		inputs: {
			workingDays: { variable: 'workingDays' },
			purchaseCosts: { variable: 'purchaseCostsApples' }
		},
		f: 'i.purchaseCosts/i.workingDays'
	},

	avarageDailyPurchaseCostsBottles: {
		inputs: {
			workingDays: { variable: 'workingDays' },
			purchaseCosts: { variable: 'purchaseCostsBottles' }
		},
		f: 'i.purchaseCosts/i.workingDays'
	},

	supplierAccountPayables: {
		inputs: {
			avarageDailyPurchaseCostsApples: {
				variable: 'avarageDailyPurchaseCostsApples'
			},
			avarageDailyPurchaseCostsBottles: {
				variable: 'avarageDailyPurchaseCostsBottles'
			},
			daysInPayablesApples: { variable: 'daysInPayablesApples' },
			daysInPayablesBottles: { variable: 'daysInPayablesBottles' }
		},
		f:
			'i.avarageDailyPurchaseCostsApples*i.daysInPayablesApples+i.avarageDailyPurchaseCostsBottles*i.daysInPayablesBottles'
	},

	accountPayables: {
		inputs: {
			supplierAccountPayables: { variable: 'supplierAccountPayables' },
			outsourcingAccountPayables: { variable: 'outsourcingAccountPayables' }
		},
		f: 'i.supplierAccountPayables+i.outsourcingAccountPayables'
	},

	avarageDailyRevenue: {
		inputs: {
			revenues: { variable: 'revenues' },
			workingDays: { variable: 'workingDays' }
		},
		f: 'i.revenues/i.workingDays'
	},

	accountReceivables: {
		inputs: {
			avarageDailyRevenue: { variable: 'avarageDailyRevenue' },
			daysReceivable: { variable: 'daysReceivable' }
		},
		f: 'i.avarageDailyRevenue*i.daysReceivable'
	},

	receivablesDelta: {
		inputs: {
			accountReceivables: { variable: 'accountReceivables' },
			accountReceivables_last: { variable: 'accountReceivables', timeshift: 1 }
		},
		f: 'i.accountReceivables_last - i.accountReceivables'
	},

	payablesDelta: {
		inputs: {
			accountPayables: { variable: 'accountPayables' },
			accountPayables_last: { variable: 'accountPayables', timeshift: 1 }
		},
		f: 'i.accountPayables - i.accountPayables_last'
	},

	directMaterialUnitaryCost: {
		inputs: {
			directMaterialCosts: { variable: 'directMaterialCosts' },
			soldUnits: { variable: 'soldUnits' }
		},
		f: 'i.directMaterialCosts/i.soldUnits'
	},

	finishedGoodsUnitaryCosts: {
		inputs: {
			directMaterialCosts: { variable: 'directMaterialCosts' },
			soldUnits: { variable: 'soldUnits' },
			productionOverheads: { variable: 'productionOverheads' },
			externallyProducedUnits: { variable: 'externallyProducedUnits' }
		},
		f:
			'(i.directMaterialCosts + i.productionOverheads)/(i.soldUnits - i.externallyProducedUnits)'
	},

	finishedGoodsInventory: {
		inputs: {
			endingWhJuice: { variable: 'endingWhJuice' },
			endingWhJuice_last: { variable: 'endingWhJuice', timeshift: 1 },
			finishedGoodsUnitaryCosts: { variable: 'finishedGoodsUnitaryCosts' },
			finishedGoodsUnitaryCosts_last: {
				variable: 'finishedGoodsUnitaryCosts',
				timeshift: 1
			},
			finishedGoodsInventory_last: {
				variable: 'finishedGoodsInventory',
				timeshift: 1
			}
		},
		f:
			'Math.max(0,(i.endingWhJuice-i.endingWhJuice_last)*i.finishedGoodsUnitaryCosts+i.finishedGoodsInventory_last)'
	},

	totalRawMaterialInventory: {
		inputs: {
			rawMaterialInventoryBottles: { variable: 'rawMaterialInventoryBottles' },
			rawMaterialInventoryApples: { variable: 'rawMaterialInventoryApples' }
		},
		f: 'i.rawMaterialInventoryBottles + i.rawMaterialInventoryApples'
	},

	rawMaterialInventoryBottles: {
		inputs: {
			supplierBottleChoice: { variable: 'supplierBottleChoice' },
			c1: { variable: 'supplier1CostBottles' },
			c2: { variable: 'supplier2CostBottles' },
			c3: { variable: 'supplier3CostBottles' },
			endingWhBottles: { variable: 'endingWhBottles' }
		},
		f: '[i.c1,i.c2,i.c3][i.supplierBottleChoice-1] * i.endingWhBottles'
	},

	rawMaterialInventoryApples: {
		inputs: {
			supplierAppleChoice: { variable: 'supplierAppleChoice' },
			c1: { variable: 'supplier1CostApples' },
			c2: { variable: 'supplier2CostApples' },
			c3: { variable: 'supplier3CostApples' },
			endingWhApples: { variable: 'endingWhApples' }
		},
		f: '[i.c1,i.c2,i.c3][i.supplierAppleChoice-1] * i.endingWhApples'
	},

	totalCurrentAssets: {
		inputs: {
			cash: { variable: 'cash' },
			accountReceivables: { variable: 'accountReceivables' },
			totalRawMaterialInventory: { variable: 'totalRawMaterialInventory' },
			finishedGoodsInventory: { variable: 'finishedGoodsInventory' }
		},
		f:
			'i.cash + i.accountReceivables + i.totalRawMaterialInventory + i.finishedGoodsInventory'
	},

	inventory: {
		inputs: {
			totalRawMaterialInventory: { variable: 'totalRawMaterialInventory' },
			finishedGoodsInventory: { variable: 'finishedGoodsInventory' }
		},
		f: 'i.totalRawMaterialInventory+i.finishedGoodsInventory'
	},

	inventoryDelta: {
		inputs: {
			inventory: { variable: 'inventory' },
			inventory_last: { variable: 'inventory', timeshift: 1 }
		},
		f: 'i.inventory_last - i.inventory'
	},

	netFixedAssets: {
		inputs: {
			fixedAssets: { variable: 'fixedAssets' },
			accumulatedDepreciation: { variable: 'accumulatedDepreciation' }
		},
		f: 'i.fixedAssets-i.accumulatedDepreciation'
	},

	totalAssets: {
		inputs: {
			totalCurrentAssets: { variable: 'totalCurrentAssets' },
			netFixedAssets: { variable: 'netFixedAssets' }
		},
		f: 'i.totalCurrentAssets+i.netFixedAssets'
	},

	currentLiabilities: {
		inputs: {
			accountPayables: { variable: 'accountPayables' },
			shortTermDebts: { variable: 'shortTermDebts' }
		},
		f: 'i.accountPayables+i.shortTermDebts'
	},

	totalLiabilities: {
		inputs: {
			currentLiabilities: { variable: 'currentLiabilities' },
			longTermDebt: { variable: 'longTermDebt' }
		},
		f: 'i.currentLiabilities+i.longTermDebt'
	},

	totalEquity: {
		inputs: {
			equity: { variable: 'equity' },
			retainedEarnings: { variable: 'retainedEarnings' },
			netIncome: { variable: 'netIncome' }
		},
		f: 'i.equity+i.retainedEarnings+i.netIncome'
	},

	retainedEarnings: {
		inputs: {
			retainedEarnings_last: { variable: 'retainedEarnings', timeshift: 1 },
			netIncome_last: { variable: 'netIncome', timeshift: 1 }
		},
		f: 'i.netIncome_last + i.retainedEarnings_last'
	},

	totalLiabilitiesAndEquity: {
		inputs: {
			totalLiabilities: { variable: 'totalLiabilities' },
			totalEquity: { variable: 'totalEquity' }
		},
		f: 'i.totalLiabilities+i.totalEquity'
	},

	totalBuildings: {
		inputs: {
			machines: { variable: 'machines' },
			machinesPerBuilding: { variable: 'machinesPerBuilding' }
		},
		f: 'Math.ceil( i.machines / i.machinesPerBuilding )'
	},

	buildingRentTotal: {
		inputs: {
			totalBuildings: { variable: 'totalBuildings' },
			buildingRentUnit: { variable: 'buildingRentUnit' }
		},
		f: 'i.buildingRentUnit * i.totalBuildings'
	}
};
export default functions;
